import React, { useState, useEffect } from "react";
import { Grid, Tab, Tabs, Button, Typography } from "@mui/material";
import { Dialog } from "@progress/kendo-react-dialogs";
import IFWUserList from "../components/ifw-user-list";
import ClientList from "../components/client-list";
import UserDetails from "../components/user-details";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import {
  USER_FINANCIALPROFESSIONAL,
  USER_CASEDESIGNER,
  USER_CONCIERGE,
  USER_SUPERADMIN,
  SAGA_CREATE_USER,
  SAGA_EDIT_USER,
  SAGA_RELOAD_USER_LIST,
  ACTION_SET_CURRENTFP_ID
} from "../shared/constants";
import { getConciergeFinancialProfessionals } from '../shared/api'
import SuccesDialog from "../components/success-dialog";
import UserManagementModal from "../components/user-management-modal";

const IFWUsers = () => {
  const [cookies, setCookie] = useCookies(["loginToken"]);
  const { tabIndex, idIncomeUser } = useParams();

  const dispatch = useDispatch();
  const history = useHistory()

  const authToken = useSelector((state) =>
    state.dataStore.getIn(["loginInfo", "authorizationToken"])
  );

  const authorization = useSelector((state) =>
    state.dataStore.getIn(["currentUser", "authorization"])
  );

  const currentUser = useSelector((state) =>
    state.dataStore.get("currentUser")
  ).toJS();

  const advisorId = useSelector((state) =>
    state.dataStore.getIn(["loginInfo", "advisorId"]))

  const userId = useSelector((state) =>
    state.dataStore.getIn(["loginInfo", "userId"]))

  const currentFinancialProfessional = useSelector(state =>
    state.dataStore.getIn(['financialProfessional'])
  ).toJS();

  const [state, setState] = useState({
    showFinancialProModal: false,
    userSucefully: { show: false, message: "" },
    selectedUser:
      authorization === USER_FINANCIALPROFESSIONAL
        ? {
          id: advisorId,
          firstName: currentUser.firstName,
          lastName: currentUser.lastName
        }
        : null,
    tabIndex:
      authorization === USER_SUPERADMIN
        ? 0
        : authorization === USER_CONCIERGE ||
          authorization === USER_CASEDESIGNER
          ? 1
          : 2,
    fpBindingConcierge: [],
    showSettingsModal: false
  });

  useEffect(() => {
    setCookie("loginToken", authToken, { path: "/" });
  }, []);

  const handleChange = (event, newValue) => {
    setState({
      ...state,
      tabIndex: newValue,
      selectedUser: null,
    });
  };

  useEffect(() => {
    if (authorization === USER_CONCIERGE) {
      getConciergeFinancialProfessionals(userId, authToken).then((response) => {
        setState((c) => ({ ...c, fpBindingConcierge: response.map(e => e.id) }))
      })
    }
    setState((c) => ({ ...c, tabIndex: parseInt(tabIndex) }));
  }, []);

  useEffect(() => {
    dispatch({
      type: ACTION_SET_CURRENTFP_ID,
      value: null
    });
  }, []);

  const addNewUser = () => {
    setState({
      ...state,
      showFinancialProModal: true,
      selectedUser: null,
    });
  };

  const addNewPlan = () => {
    history.push(
      `/financial-professionals/${currentFinancialProfessional.advisorId}/clients/null/plan-inputs`
    );
  }

  const save = (user) => {
    dispatch({
      type: SAGA_CREATE_USER,
      value: user,
    });

    dispatch({
      type: SAGA_RELOAD_USER_LIST,
      value: null
    });

    setState({
      ...state,
      showFinancialProModal: false,
      userSucefully: { show: true, message: "User has been added" }

    });
  };

  const edit = (user) => {
    dispatch({
      type: SAGA_EDIT_USER,
      value: user,
    });

    dispatch({
      type: SAGA_RELOAD_USER_LIST,
      value: null
    });

    setState({
      ...state,
      showFinancialProModal: false,
      userSucefully: { show: true, message: "User information has been successfully saved" }
    });
  };


  const cancel = () => {
    setState({
      ...state,
      showFinancialProModal: false,
    });
  };

  const showEdit = (user) => {
    setState({
      ...state,
      showFinancialProModal: true,
      selectedUser: user,
    });
  };

  const showSettings = (user) => {
    setState({
      ...state,
      showSettingsModal: true,
      selectedUser: user
    });
  };


  const styleRigthSide = { height: '100%', minWidth: '131px', marginRight: '10px', fontSize: 'calc(0.45vw + 5px)' }

  return (
    <React.Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12} >
          <Grid container>
            <Grid item xs={8}>
              <Tabs value={state.tabIndex} onChange={handleChange}>
                {authorization === USER_SUPERADMIN && (
                  <Tab label="IFW List" value={0} />
                )}
                {authorization !== USER_FINANCIALPROFESSIONAL && (
                  <Tab label="FP List" value={1} />
                )}
                <Tab label="Client List" value={2} />
              </Tabs>
            </Grid>
            <Grid item xs={4} display={'flex'} alignItems={'flex-end'} >
              <Grid
                container
                display={'flex'}
                justifyContent={'end'}
                flexDirection={"row"}
                mr={3}
                sytle={{ height: '100%', width: '100%' }} >
                <Grid style={{ height: '42px', display: 'flex' }}  >
                  {(state.tabIndex === 0 || state.tabIndex === 1) &&
                    authorization === USER_SUPERADMIN && (
                      <Button
                        style={styleRigthSide}
                        onClick={addNewUser}>{"Add new user"}
                      </Button>
                    )}
                  {state.tabIndex === 2 && (
                    <Button
                      className={state.selectedUser === null ? "disabled-button" : ""}
                      disabled={state.selectedUser === null}
                      style={{ ...styleRigthSide }}
                      onClick={addNewPlan}>
                      {"Add new plan"}
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {state.tabIndex === 0 && (
          <Grid item xs={12}>
            <IFWUserList isIFWList={true} edit={showEdit} settings={showSettings} />
          </Grid>
        )}
        {state.tabIndex === 1 && (
          <Grid item xs={12}>
            <IFWUserList
              isIFWList={false}
              edit={showEdit}
              settings={showSettings}
              fpBindingConcierge={state.fpBindingConcierge}
              onRowClick={(event) => {
                setState({
                  ...state,
                  tabIndex: 2,
                  selectedUser: event.dataItem,
                });
              }}
            />
          </Grid>
        )}
        {state.tabIndex === 2 && (
          <Grid item xs={12}>
            <ClientList
              fpBindingConcierge={state.fpBindingConcierge}
              selectedUser={state.selectedUser}
            setSelectedUser={setState}
            />
          </Grid>
        )}
      </Grid>
      {state.showFinancialProModal && (
        <Dialog
          onClose={() => {
            setState({
              ...state,
              showFinancialProModal: false,
            });
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <UserDetails user={state.selectedUser} save={save} edit={edit} cancel={cancel} />
        </Dialog>
      )}
      {state.showSettingsModal && (
        <UserManagementModal user={state.selectedUser} close={() => {
          dispatch({
            type: SAGA_RELOAD_USER_LIST,
            value: null
          });

          setState({
            ...state,
            showSettingsModal: false
          });
        }} />
      )}
      <SuccesDialog
        handleOk={() => {
          setState({
            ...state,
            userSucefully: { show: false, message: "" }
          })
        }}
        open={state.userSucefully.show}
        message={state.userSucefully.message}
      />
    </React.Fragment >
  );
};

export default IFWUsers;
